import React from "react";
import TweetApiClient from "./TweetAPIClient";


const TweetList = () => {
  return(
      <div>
        <TweetApiClient/>
      </div>
  );
};
export default TweetList;